import { render } from "./QuizPage.vue?vue&type=template&id=74b55548&scoped=true"
import script from "./QuizPage.vue?vue&type=script&lang=js"
export * from "./QuizPage.vue?vue&type=script&lang=js"

import "./QuizPage.vue?vue&type=style&index=0&id=74b55548&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74b55548"]])

export default __exports__